import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-b', 'IconLetterB', [
  ['path', { d: 'M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6', key: 'svg-0' }],
  ['path', { d: 'M7 12l6 0', key: 'svg-1' }],
]);
